import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    eventoId: 0,
    evento: null,
    eventoNombre: null,
    eventoEtapaId: 0,
    eventoEtapa: null,
    eventoEtapaNombre: null,
    file: null,

    registros: 0,
    errores: [],

    eventoEtapas: [],
    eventoEtapasList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.eventoId = 0;
        state.evento = null;
        state.eventoNombre = null;
        state.eventoEtapaId = 0;
        state.eventoEtapa = null;
        state.eventoEtapaNombre = null;
        state.file = null;
        state.registros = 0;
        state.errores = [];

        state.eventoEtapas = [];
        state.eventoEtapasList = [];
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;

        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
        
        state.eventoId = 0;
        state.evento = null;
        state.eventoNombre = null;
        state.eventoEtapaId = 0;
        state.eventoEtapaNombre = null;
        state.eventoEtapas = [];
        state.eventoEtapasList = [];
    },
    'SET_EVENTO'(state, evento) {
        state.evento = evento;
        if (evento) {
            state.eventoId = evento.id? evento.id : 0;
            state.eventoNombre = evento.nombre? evento.nombre.trim() : null;
        } else {
            state.eventoId = 0;
            state.eventoNombre = null;
        }

        state.eventoEtapaId = 0;
        state.eventoEtapaNombre = null;
        state.eventoEtapas = [];
        state.eventoEtapasList = [];
    },
    'SET_EVENTO_ETAPAS'(state, eventoEtapas) {
        state.eventoEtapas = eventoEtapas;
        state.eventoEtapasList = eventoEtapas.map(item => item.nombre.trim());
    },
    'SET_EVENTO_ETAPA'(state, eventoEtapa) {
        state.eventoEtapa = eventoEtapa;
        if (eventoEtapa) {
            state.eventoEtapaId = eventoEtapa.id? eventoEtapa.id : 0;
            state.eventoEtapaNombre = eventoEtapa.nombre? eventoEtapa.nombre.trim() : null;
        } else {
            state.eventoEtapaId = 0;
            state.eventoEtapaNombre = null;
        }
    },
    'SET_RESULTADOS' (state, resultados) {
        state.registros = resultados.registros;
        state.errores = resultados.errores;
    },   
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');
            resolve();
        })
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },
    setEvento: ( { commit }, evento) => {
        return new Promise((resolve, reject) => {
            commit('SET_EVENTO', evento);

            let getEtapas = false;

            if (evento) {
                if (evento.id) {
                    if (evento.id != 0) {
                        getEtapas = true;
                    }
                }
            }
            if (getEtapas) {
                apiAxios.get(`eventos/${evento.id}/etapas`)
                    .then(res => {
                        commit('SET_EVENTO_ETAPAS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                resolve();
            }
        })

    },
    setEventoEtapa: ({commit}, eventoEtapa) => {
        commit('SET_EVENTO_ETAPA', eventoEtapa);
    },
    importarMontosTransferir ( { commit } ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = state.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(state.file.size / 1048576);

            if (state.eventoId == 0) {
                error = 'Debe seleccionar el evento correspondiente.';
            }

            if (!state.file) {
                error = 'Debe seleccionar el archivo a importar.';
            }

            if (fileExtension != 'csv') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten archivos de tipo csv.';
            }

            // if (fileSize >= 1 ) {
            //     error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 1MB.';
            // }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', state.file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

                apiAxios.post(`edi/import/eventos/${state.eventoId}/etapas/${state.eventoEtapaId}/montos-transferir/file`, formData, options)
                    .then(res => {
                        commit('SET_RESULTADOS', res.data);    
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}